import { useEffect, useState } from "react";
import GenericMazeActivity from "./Mazes";

export default function Level7_AdvancedMazes(props) {
  return (
    <GenericMazeActivity
      open={props.open}
      openActivity={props.openActivity}
      changePdf={props.changePdf}
      config={{
        mode: "progression-groups",
        basePath: "/VisuallyDirectedFineMotor/AdvancedMazes",
        defaultProgression: "Level1",
        defaultGroup: "A",
        changePdf: true,
        showLanding: false,
        options: {
          progressions: [
            {
              id: "Level1",
              label: "Start Small",
              groups: [
                {
                  id: "A",
                  label: "Group A",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
                {
                  id: "B",
                  label: "Group B",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
              ]
            },
            {
              id: "Level2",
              label: "Tricky Travels",
              groups: [
                {
                  id: "A",
                  label: "Group A",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
                {
                  id: "B",
                  label: "Group B",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
              ]
            },
            {
              id: "Level3",
              label: "Experts Only",
              groups: [
                {
                  id: "A",
                  label: "Group A",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
                {
                  id: "B",
                  label: "Group B",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
              ]
            },
            {
              id: "Level4",
              label: "Buried Treasure",
              groups: [
                {
                  id: "A",
                  label: "Group A",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                    { id: "5", label: "Maze 5" }
                  ],
                },
                {
                  id: "B",
                  label: "Group B",
                  mazes: [
                    { id: "1", label: "Maze 1" },
                    { id: "2", label: "Maze 2" },
                    { id: "3", label: "Maze 3" },
                    { id: "4", label: "Maze 4" },
                  ],
                },
              ],
            },
            
          ],
        },
      }}

    />
  );
}